import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=e51b54ec&scoped=true"
import script from "./Locality.vue?vue&type=script&lang=js"
export * from "./Locality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51b54ec",
  null
  
)

export default component.exports